import { createStore, applyMiddleware } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import composeWithDevtools from '@atlassian/jira-common-util-compose-with-devtools/src/index.tsx';
import rootEpic from './epics.tsx';
import rootReducer from './reducers.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const createStore1 = (initialState: any) =>
	createStore(
		// @ts-expect-error - TS2345 - Argument of type '(state: { context: undefined; dialog: undefined; newLocation: undefined; } | undefined, action: any) => unknown' is not assignable to parameter of type 'Reducer<{ context: undefined; dialog: undefined; newLocation: undefined; } | undefined>'.
		rootReducer,
		initialState,
		composeWithDevtools({ name: 'Move Single Board' })(
			applyMiddleware(createEpicMiddleware(rootEpic)),
		),
	);

export default createStore1;
